import { render, staticRenderFns } from "./DriverBlackListEdit.vue?vue&type=template&id=643b47a2&scoped=true"
import script from "./DriverBlackListEdit.vue?vue&type=script&lang=js"
export * from "./DriverBlackListEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643b47a2",
  null
  
)

export default component.exports